// @core/api/endpoints/chat/unsubscribe_from_mention_tag.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/chat';

/**
 * Unsubscribe from a mention tag
 * Removes the current user's subscription to a mention tag.
 */
export async function UnsubscribeFromMentionTag(
  conversation_id: string,
  mention_tag_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/mention-tags/:mention_tag_id/subscribe`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':mention_tag_id', encodeURIComponent(mention_tag_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
